import { useField } from 'formik';
import {
  NumericFormat,
  NumericFormatProps,
} from 'react-number-format';

import { BaseTextField, BaseTextFieldProps } from '../BaseTextField';
import isNil from 'lodash/isNil';


export type NumberInputProps = Omit<BaseTextFieldProps, 'defaultValue' | 'type'> & {
  name: string;
  numberInputProps?: Omit<NumericFormatProps, 'customInput' | 'color' | 'size'>;
  asString?: boolean;
  // matching the formik validate function definition
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validate?: (value: any) => undefined | string | Promise<any>;
};


export const NumberInput: React.FC<NumberInputProps> = ({ numberInputProps, asString, validate, ...props }) => {
  const [
    {
      onChange: _onChange,
      ...field
    },
    meta,
    helpers
  ] = useField<number | string | null>({
    name: props.name,
    validate: validate,
  });

  return (
    <NumericFormat
      customInput={BaseTextField}
      {...numberInputProps}

      {...field}
      {...props}
      value={field.value}
      errorHelperText={meta.error}
      error={Boolean(meta.touched && !isNil(meta.error))}

      onValueChange={({ floatValue }) => {
        if (asString) {
          helpers.setValue(floatValue?.toString() ?? null);
        } else {
          helpers.setValue(floatValue ?? null);
        }
      }}
    />
  );
};
